import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { trackEvent } from '../utils/analytics';

const WHATSAPP_LINK = "https://wa.me/393921037894?text=Ciao%2C%20vorrei%20un%20preventivo%20gratuito%20per%20uno%20sgombero.%20Posso%20inviarvi%20le%20foto%3F";
const LOGO_URL = "https://media-manager-c.questera.ai/greta-media/199587cac76451c8a0c81fe29a304b4dfef859bf4c50d3d87f3dadd96dddc39882a7b9b97ef41b50b9892514b6d5ef47/images/aW1hZ2UvcG5n/fb2dd0bcc2bb3890a66287fae4bd7f31.png";
const VAN_IMG = "https://media-manager-c.questera.ai/greta-media/199587cac76451c8a0c81fe29a304b4dfef859bf4c50d3d87f3dadd96dddc39882a7b9b97ef41b50b9892514b6d5ef47/images/aW1hZ2UvcG5n/5b60173f246ec5217703ffc80df04c08.png";

export default function Hero() {
  return (
    <section className="relative min-h-[90svh] flex flex-col justify-center items-center bg-maaich-black overflow-hidden pt-28 pb-12 lg:pt-0">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-maaich-green/10 via-maaich-black to-maaich-black pointer-events-none"></div>
      
      <header className="absolute top-0 left-0 w-full p-4 md:p-8 z-40 flex justify-between items-center">
        <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} className="flex-shrink-0">
          <img src={LOGO_URL} alt="MAAICH Sgomberi Logo" className="h-14 md:h-20 w-auto object-contain mix-blend-lighten" fetchPriority="high" width="180" height="80" />
        </motion.div>
        <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.5 }} className="hidden sm:block">
          <div className="bg-maaich-lime text-maaich-black px-4 py-2 font-display text-xl uppercase italic transform -skew-x-12 shadow-xl">
            Sgomberi Professionali
          </div>
        </motion.div>
      </header>

      <div className="container mx-auto px-5 z-10 grid lg:grid-cols-12 gap-12 items-center h-full">
        <motion.div className="lg:col-span-7 flex flex-col justify-center text-left" initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
          <h1 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-display leading-[1] uppercase italic text-white mb-6">
            Sgombero appartamenti <br className="hidden sm:block"/> e locali a <span className="text-maaich-lime">Varese, Como, Bergamo, Lecco</span> e <span className="text-maaich-lime">Brianza</span>
          </h1>
          <p className="text-lg md:text-xl text-white/80 max-w-2xl font-body font-light border-l-2 border-maaich-lime pl-5 mb-10 leading-relaxed">
            Svuotiamo case, cantine, uffici e magazzini in modo rapido, sicuro e a norma di legge in tutta la Lombardia nord. Preventivo gratuito: bastano poche foto su WhatsApp.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <a 
              href={WHATSAPP_LINK} 
              target="_blank" 
              rel="noreferrer" 
              onClick={() => trackEvent('whatsapp_click', 'hero')}
              className="w-full sm:w-auto bg-maaich-lime hover:bg-white text-maaich-black font-display text-xl px-8 py-5 uppercase italic transition-all duration-300 flex items-center justify-center gap-3 active:scale-95 shadow-lg shadow-maaich-lime/20"
            >
              <SafeIcon icon={FiIcons.FiMessageCircle} className="text-2xl" /> Scrivici su WhatsApp
            </a>
            <a 
              href="tel:+393516488306" 
              onClick={() => trackEvent('phone_click', 'hero')}
              className="w-full sm:w-auto border-2 border-white/20 hover:border-white text-white font-display text-lg px-8 py-5 uppercase italic transition-all duration-300 flex items-center justify-center gap-2 active:scale-95"
            >
              <SafeIcon icon={FiIcons.FiPhoneCall} className="text-xl" /> Chiama 351 648 8306
            </a>
          </div>
        </motion.div>

        <motion.div className="lg:col-span-5 relative w-full lg:mt-0 flex items-center justify-center" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1, delay: 0.2 }}>
          <div className="relative w-full max-w-[550px] rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.6)] border border-white/10 group">
            <div className="absolute inset-0 bg-gradient-to-t from-maaich-black via-transparent to-transparent z-10 pointer-events-none"></div>
            <img 
              src={VAN_IMG} 
              alt="Furgone MAAICH Sgomberi per sgomberi rapidi in Lombardia" 
              className="w-full aspect-[4/3] object-cover object-center transform group-hover:scale-105 transition-transform duration-[2000ms]" 
              fetchPriority="high"
              width="550"
              height="412"
            />
            <div className="absolute bottom-6 left-6 z-20">
              <div className="bg-maaich-black/90 backdrop-blur-md border border-maaich-lime/30 p-4 rounded-lg">
                <div className="flex items-center gap-3">
                  <div className="w-2.5 h-2.5 bg-maaich-lime rounded-full animate-pulse"></div>
                  <span className="font-display text-white italic uppercase text-sm tracking-widest">INTERVENTI RAPIDI IN 24/48H</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}